import { useModal } from "@/comn/hooks/useModal";
import { comnUtils } from "@/comn/utils";
import { useEffect } from "react";
import { useRecoilState } from "recoil";
import { authState } from "@/comn/features/recoil";
import { PwdAuth } from "@/comn/comn/auth/PwdAuth";
import { useNavigate } from "react-router-dom";
import {ENUMS} from "@/comn/comn/auth/services/PwdAuthService";
/*
 * Password Authentication HOOK
 * !== 비밀번호 인증 HOOK ==!
 */
export const usePwdAuth = (props?:any) => {
    const modal    = useModal();
    const [auth]   = useRecoilState(authState);
    const ppupId   = "pwdAuth";
    const navigate = useNavigate();
    const {auto, callback} = props || { auto: true, callback: null };

    useEffect(() => {
        auto !== false && open();
    }, []);

    const close = (type:any) => {
        type === ENUMS.OK && callback && callback();
        modal.closeModal(ppupId);
    }

    const open = () => {
        const { userInfo } = auth;
        if (comnUtils.isEmpty(userInfo.lgnTp)) return;

        modal.closeModal(ppupId);
        modal.openModal({
            id: ppupId,
            content: <PwdAuth close={close} auto={auto}/>,
            close: false,
            onClose: () => {
                auto !== false && navigate(process.env.REACT_APP_BASE || "");
            },
        });
    };

    return { open };
};
